import { Link } from "react-router-dom";
import type { ReactNode } from "react";

interface SectionTitleProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: ReactNode;
}

export default function SectionTitle({
  eyebrow,
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
  icon,
}: SectionTitleProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div className="min-w-0">
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
            {icon && <span className="w-3.5 h-3.5 flex items-center justify-center">{icon}</span>}
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
        {subtitle && <p className="mt-1.5 text-sm text-foreground-600">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="hidden shrink-0 items-center gap-1 text-sm text-primary-700 hover:text-accent-700 transition-colors sm:flex"
        >
          {moreLabel}
          <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
        </Link>
      )}
    </div>
  );
}